import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import '../technologies/Technologies.css';

const categories = [ "FrontEnd","Backend", "Database", "Mobile", "CMS", "Infra and DevOps", "Integrations"];

const techStacks = {
  
    FrontEnd: [
      { name: "HTML", image: "/assets/images/technologies/frontend/html.png", alt:"HTML" },
      { name: "CSS", image: "/assets/images/technologies/frontend/css.png", alt:"CSS" },
      { name: "Javascript", image: "/assets/images/technologies/frontend/Javascript.png", alt:"Javascript" },
      { name: "Jquery", image: "/assets/images/technologies/frontend/jquery.png", alt:"jquery" },
      { name: "Bootstrap", image: "/assets/images/technologies/frontend/bootstrap.png", alt:"Bootstrap" },
      { name: "Sass", image: "/assets/images/technologies/frontend/sass.png", alt:"Sass" },
      { name: "TypeSricpt", image: "/assets/images/technologies/frontend/typeSricpt.png", alt:"TypeSricpt" },
      { name: "React", image: "/assets/images/technologies/frontend/react.png", alt:"React" },
      { name: "Angular", image: "/assets/images/technologies/frontend/angular.png", alt:"Angular" },
      { name: "Vue.js", image: "/assets/images/technologies/frontend/vue.png", alt:"Vue.js" },
      { name: "Redux.js", image: "/assets/images/technologies/frontend/redux.png", alt:"Redux.js" },
      { name: "Ruby.js", image: "/assets/images/technologies/frontend/ruby.png", alt:"Ruby.js" },
      { name: "Webpack", image: "/assets/images/technologies/frontend/webpack.png", alt:"Webpack" },
    ],
    Backend: [
      { name: "C#", image: "/assets/images/technologies/backend/c-sharp.png", alt:"C#"  },
      { name: ".NET", image: "/assets/images/technologies/backend/dot-net.png", alt:".NET"   },
      { name: "ASP.NET MVC", image: "/assets/images/technologies/backend/asp-net-mvc.png", alt:"ASP.NET MVC"  },
      { name: ".NET Core", image: "/assets/images/technologies/backend/NET-core.png", alt:".NET Core"  },
      { name: "ASP.NET Core", image: "/assets/images/technologies/backend/ASP_NET_Core.png", alt:"ASP.NET Core" },
      { name: "Web API", image: "/assets/images/technologies/backend/application-programming-interface.png", alt:"Web API" },
      { name: "Entity Framework", image: "/assets/images/technologies/backend/entity-framework.png", alt:"Entity Framework"},
      { name: "Node.js", image: "/assets/images/technologies/backend/node-js.png", alt:"Node.js" },
    ],
    Database: [
      { name: "MS SQL 2016", image: "/assets/images/technologies/database/mysql-2016.png", alt:"MS SQL 2016" },
      { name: "MySQL", image: "/assets/images/technologies/database/mysql.png", alt:"MS SQL" },
      { name: "MongoDB", image: "/assets/images/technologies/database/mongoDB.png", alt:"MongoDB"  },
      { name: "NoSQL", image: "/assets/images/technologies/database/noSQL.png", alt:"NoSQL"  },
      { name: "Oracle", image: "/assets/images/technologies/database/oracle.png", alt:"Oracle"  },
      { name: "SQL", image: "/assets/images/technologies/database/sql.png", alt:"SQL"  },
    ],
    Mobile: [
      { name: "Swift", image: "/assets/images/technologies/mobile/swift.png", alt:"Swift"  },
      { name: "Objective-C",image: "/assets/images/technologies/mobile/objective-c.png", alt:"Objective-C" },
      { name: "Android Studio", image: "/assets/images/technologies/mobile/android-studio.png", alt:"Android Studio" },
      { name: "Java", image: "/assets/images/technologies/mobile/java.png", alt:"Java" },
      { name: "Xcode", image: "/assets/images/technologies/mobile/xcode.png", alt:"Xcode" },
      { name: "React Native", image: "/assets/images/technologies/mobile/react-native.png", alt:"React Native" },
      { name: "Ionic", image: "/assets/images/technologies/mobile/Ionic.png", alt:"Ionic" },
    ],
    CMS: [
      { name: "WordPress", image: "/assets/images/technologies/CMS/wordpress.png", alt:"WordPress" },
      { name: "Laravel", image: "/assets/images/technologies/CMS/laravel.png", alt:"Laravel" },
      { name: "CodeIgniter", image: "/assets/images/technologies/CMS/codeIgniter.png", alt:"CodeIgniter" },
      { name: "CakePHP", image: "/assets/images/technologies/CMS/cakephp.png", alt:"CakePHP" },
    ],
    "Infra and DevOps": [
      { name: "Microsoft Azure", image: "/assets/images/technologies/InfraDevOps/microsoft-azure.png", alt:"Microsoft Azure" },
      { name: "JIRA", image: "/assets/images/technologies/InfraDevOps/jira.png", alt:"JIRA" },
    ],
    Integrations: [
      { name: "QBO", image: "/assets/images/technologies/Integrations/QBO.png", alt:"QBO" },
      { name: "XERO", image: "/assets/images/technologies/Integrations/xero.png", alt:"XERO" },
      { name: "PayPal", image: "/assets/images/technologies/Integrations/paypal.png", alt:"PayPal" },
      { name: "Stripe", image: "/assets/images/technologies/Integrations/stripe.png", alt:"Stripe"  },
      { name: "FedEx", image: "/assets/images/technologies/Integrations/fedex.png", alt:"FedEx"},
      { name: "UPS", image: "/assets/images/technologies/Integrations/ups.png", alt:"UPS" },
      { name: "DHL", image: "/assets/images/technologies/Integrations/dhl.png", alt:"DHL" },
    ],
};

const projectSteps = [
  { step: "01", title: "Discovery & Planning", description: "We analyze your requirements and define a roadmap to achieve your objectives efficiently." },
  { step: "02", title: "Initial Consultation", description: "A key session where we align expectations, discuss strategies, establish a clear workflow." },
  { step: "03", title: "Project Blueprint", description: "We draft a comprehensive plan outlining the timeline, milestones, and deliverables." },
  { step: "04", title: "Seamless Execution", description: "Our team transforms ideas into reality, ensuring precision, efficiency, and top-quality results." },
  { step: "05", title: "Deployment & Delivery", description: "We finalize the project, conduct testing, and ensure a seamless launch with all requirements met." },
  { step: "06", title: "Ongoing Support", description: "Post-launch, we provide maintenance, updates, and support to ensure long-term success." },
];


const Technologies = () => {
  const [activeTab, setActiveTab] = useState("Backend");

  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS animations
  }, []);

  return (
    <section className="technologies">
        <div className="header" data-aos="fade-up" data-aos-delay="100">
            <div className="title">Technologies & Workflow</div>
            <p className="para mb-0">Smart Technologies, Smarter Solutions</p>
        </div>
        <div className="container mx-auto px-4">
        
        {/* Tabs */}
        <div className="technologies-tabs" data-aos="fade-up">
            <div className="flex flex-wrap justify-center gap-4 mb-5">
                {categories.map((category) => (
                <button
                    key={category}
                    onClick={() => setActiveTab(category)}
                    className={`px-4 py-2 rounded-lg font-medium ${activeTab === category ? "bg-danger text-white" : "bg-gray-100 text-black"}`}
                >
                    {category}
                </button>
                ))}
            </div>
        </div>

        {/* Swiper Slider for Tech Stack */}
        <Swiper
            slidesPerView={6}
            spaceBetween={20}
            navigation={true}
            modules={[Navigation]}
            className="mySwiper"
            data-aos="fade-up"
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 }, // Mobile devices
              480: { slidesPerView: 2, spaceBetween: 10 }, // Small screens
              768: { slidesPerView: 2, spaceBetween: 15 }, // Tablets
              1024: { slidesPerView: 3, spaceBetween: 20 }, // Laptops
              1280: { slidesPerView: 5, spaceBetween: 20 }  // Large screens
            }}
          >
            {techStacks[activeTab]?.map((tech, index) => (
            <SwiperSlide key={index} className="p-4 bg-white rounded-lg shadow-md">
                <img src={tech.image} alt={tech.name} className="w-16 mx-auto mb-2" />
                <p className="text-center text-gray-800 font-medium">{tech.name}</p>
            </SwiperSlide>
            ))}
        </Swiper>

        <hr style={{ borderColor: "rgb(227, 222, 222, 1)", margin: "2.5rem 0" }} />

        {/* Project Steps */}
        <div className="row mt-4">
        {projectSteps.map((step, index) => (
          <div key={index} className="col-md-6 col-lg-4 mb-3 technologies-tabs-block" data-aos="fade-up" data-aos-delay={index * 100}>
            <div className="card border-0 shadow rounded px-3 pb-3 position-relative overflow-hidden" style={{paddingTop:"4rem"}}>
              <div className="technologies-count">
                {step.step}
              </div>
              <h5 className="fw-bold">{step.title}</h5>
              <p className="text-muted">{step.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Get Started Button */}
      <div className="row mt-3">
        <div className="col-12 text-center" data-aos="zoom-in">
        <Link to="/contact" className="btn btn-md btn-outline-danger mt-3">Get Started</Link>
        </div>
      </div>

      </div>
    </section>
  );
};

export default Technologies;
